<template>
  <div class="tw:!mx-auto tw:!max-w-3xl">
    <Card>
      <div v-if="!ticket || ticket.status === 'draft'" class="tw:!text-center tw:!w-full">
        <div class="tw:!flex tw:!justify-center">
          <!-- <Icon name="mdi:loading" class="tw:size-10 tw:animate-spin" style="width: 2.5rem; height: 2.5rem;"/> -->
        </div>

        <p class="tw:!text-xl tw:!font-light tw:!mt-5">Please wait, onward ticket is on the way...</p>
      </div>

      <div v-else 
        style="border: 2px dashed #9ca3af; padding: 1rem; border-radius: 0.5rem; background-color: #f9fafb;"
        class="tw:border-2 tw:border-dashed tw:border-gray-400 tw:p-4 tw:rounded-lg tw:bg-gray-50">
        <div  class="tw:!grid tw:md:!grid-cols-2 tw:!gap-3">
          <div>
            <div class="tw:!text-lg">{{ ticket.flight.airline }}</div>
            <div class="tw:!text-lg">Booking Code: <span class="tw:!font-bold">{{ticket.reservation?.pnr}}</span></div>
            <div class="tw:!text-lg">Airline Booking Code: <span class="tw:!font-bold">{{ ticket.reservation?.code }}</span></div>
          </div>
          <div>
            <div class="tw:!text-lg">Flight: <span class="tw:!font-bold">{{ ticket.flight.number }}</span></div>
            <div class="tw:!text-lg">Route: <span class="tw:!font-bold">{{ ticket.from.iata }} -> {{ ticket.to.iata }}</span></div>
            <div class="tw:!text-lg">Created Date: <span class="tw:!font-bold">{{ dayjs(ticket.createdAt).format('DD/MM/YYYY HH:mm') }}</span></div>
            <!-- <p v-if="ticket.reservation?.expiredAt">
              Hold Until:
              <strong>{{ dayjs(ticket.reservation.expiredAt).format('DD/MM/YYYY HH:mm') }}</strong>
              <small> ({{ dayjs(ticket.reservation.expiredAt).fromNow() }})</small>
            </p> -->
          </div>
          <div>
            <p class="tw:!text-xl tw:!font-bold">Passengers</p>
            <div v-for="item in ticket.passengers" class="tw:!text-lg tw:!font-semibold">
              <span class="tw:!capitalize">{{ item.prefix }}. </span>
              <span class="tw:!uppercase">{{ item.first_name }}/{{ item.family_name }}</span>
            </div>
          </div>
          <div class="tw:!flex tw:!flex-wrap tw:!gap-2">
            <a v-if="ticket.itinerary_pdf_url" :href="ticket.itinerary_pdf_url" target="_blank">
              <button class="od-button" style="color:#111; text-decoration: underline">Download Itinerary</button>
            </a>
            <a v-if="ticket.pdf_url" :href="ticket.pdf_url" target="_blank">
              <button :class="ticket.itinerary_pdf_url ? 'od-button-outline' : 'od-button'" style="color:#111; text-decoration: underline">Download Ticket</button>
            </a>
            <button v-if="!ticket.pdf_url && !ticket.itinerary_pdf_url" class="od-button" disabled>
              <!-- <Icon name="mdi:loading" class="tw:animate-spin tw:mr-2" style="width: 1.5rem; height: 1.5rem;"/> -->
              Generating PDF
            </button>
          </div>
        </div>
      </div>
    </Card>
  </div>
</template>

<script lang="ts" setup>
// import Card from '~/components/base/card/Card.vue'
import dayjs from 'dayjs'
import RelativeTime from 'dayjs/plugin/relativeTime'
// import Button from '~/components/base/button/Button.vue'
import type { PaymentInvoice } from './PaymentSectionPartial.vue'
import { onMounted, ref } from 'vue'
import { axios } from '~/composables/general';
import type { AirplaneTicket } from '~/types';

dayjs.extend(RelativeTime)

const props = defineProps<{ invoice: string }>()

const invoice = ref<PaymentInvoice>()
const ticket = ref<AirplaneTicket>()

const getInvoice = async () => await axios.get<PaymentInvoice>('/public/invoice/' + props.invoice)
  .then(res => res.data)

const fetchTicket = () => {
  const timer = setInterval(async () => {
    const { data } = await axios.get<AirplaneTicket>('/public/ticket/' + ticket.value?._id)

    if (data) {
      ticket.value = data
    }

    if (data?.pdf_url || data?.itinerary_pdf_url) {
      clearInterval(timer)
    }
  }, 2500)
}

onMounted(async () => {
  invoice.value = await getInvoice()
  ticket.value = invoice.value.ticket

  fetchTicket()
})
</script>